webpackJsonp([88270027819451],{

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'routes.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file contains the route hierarchy for the application, which is a description of what should be rendered based on the URL in the web browser.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore uses ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/ReactTraining/react-router' },
	        'react-router'
	      ),
	      ' as the routing library, and makes no modifications to these routes or to the behavior of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'react-router'
	      ),
	      '. So if you have any questions about the syntax, or specific routing-related needs, all of React Router\'s ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/ReactTraining/react-router/tree/v3/docs' },
	        'documentation'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/ReactTraining/react-router/tree/v3/examples' },
	        'examples'
	      ),
	      ' will be directly applicable to Lore.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'It\'s important to mention that ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'new Lore projects include react-router v3'
	        ),
	        ', and ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'NOT v4'
	        ),
	        '. The links above go to the v3 documentation. By modifying some of configuration files in your project, it\'s possible to replace v3 with v4 (or use a different routing library altogether), but there\'s no formal guide explaining how to do it yet. Once there is, a link will be provided here.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In the future, Lore will ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'probably'
	        ),
	        ' switch to v4 as the default, but it needs to be explored more.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Defaults'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default file included in new projects looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import { Route, IndexRoute, Redirect } from \'react-router\';\n\n      /**\n       * Wrapping the Master component with this decorator provides an easy way\n       * to redirect the user to a login experience if we don\'t know who they are.\n       */\n      import UserIsAuthenticated from \'./src/decorators/UserIsAuthenticated\';\n\n      /**\n       * Routes are used to declare your view hierarchy\n       * See: https://github.com/ReactTraining/react-router/blob/v3.2.1/docs/API.md\n       */\n      import Master from \'./src/components/Master\';\n      import Layout from \'./src/components/Layout\';\n      import Feed from \'./src/components/Feed\';\n\n      export default (\n        <Route component={UserIsAuthenticated(Master)}>\n          <Route path="/" component={Layout}>\n            <IndexRoute component={Feed} />\n          </Route>\n        </Route>\n      );\n\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-routes-js-fa3bb6531a02818122e0.js